export default __webpack_public_path__ + "46d674b46eeb448e8961027045a15152.svg";